/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import { FinancingLoanType } from '@/constants/common';
import {
  DEFAULT_LOAN_DETAILS_AGE_65,
  MEDIUM_TERM_INTEREST_RATE,
  NumberOfResidentialLoans,
} from '@/constants/private-resale/tdsr';

export const initialState = {
  formField: {
    loanType: FinancingLoanType.sixtyFiveYearLoan,
    loanTenure: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TENURE_MAX.toString(),
    mediumTermInterestRate: MEDIUM_TERM_INTEREST_RATE.DEFAULT,
    loanToValue: DEFAULT_LOAN_DETAILS_AGE_65.LOAN_TO_VALUE_MAX.toString(),
    profiles: [
      {
        name: 'Profile A',
        age: '',
        availableCash: '',
        availableCPFInOA: '',
        monthlyFixedIncome: '',
        monthlyVariableIncome: '',
        monthlyOtherIncome: '',
        numberOfResidentialLoan: NumberOfResidentialLoans.NoLoan,
        monthlyResidentialInstalment: '',
        monthlyCarLoanInstalment: '',
        monthlyOtherDebt: '',
      },
    ],
  },
  loading: true,
};

export const tdsrSlice = createSlice({
  name: 'tdsr',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = tdsrSlice.actions;

export default tdsrSlice.reducer;
